import { getDefaultCreditNoteBillingPeriod } from 'CreditNotes/utils/getDefaultCreditNoteBillingPeriod.ts'
import { toApiDateTime } from 'CreditNotes/utils/toApiDateTime.ts'

/**
 * Derives the credit note billing period from an invoice's billing period,
 * falling back to the current month when the invoice has none.
 */
export function getCreditNoteBillingPeriod(
  billingPeriod: { start: string; endInclusive: string } | undefined
): {
  billingPeriodStart: string
  billingPeriodEnd: string
} {
  if (!billingPeriod) {
    return getDefaultCreditNoteBillingPeriod()
  }

  return {
    billingPeriodStart: toApiDateTime(billingPeriod.start),
    billingPeriodEnd: toApiDateTime(billingPeriod.endInclusive)
  }
}
